export const SET_PRODUITS = 'SET_PRODUITS';
export const SET_TOTAL_PRODUITS = 'SET_TOTAL_PRODUITS';
export const SET_TYPE_PRODUITS = 'SET_TYPE_PRODUITS';
export const SET_CRITERE_PLANNING = 'SET_CRITERE_PLANNING';
export const SET_LOGO = 'SET_LOGO';
export const CLEAR_PANIER = 'CLEAR_PANIER';
export const ADD_PANIER = 'ADD_PANIER';
export const ADD_PERIOD = 'ADD_PERIOD';
export const SET_PRIX = 'SET_PRIX';
export const TOGGLE_SELECTION_PLANNING = 'TOGGLE_SELECTION_PLANNING';
export const DELETE_PERIOD = 'DELETE_PERIOD';
export const SET_BRIEF = 'SET_BRIEF';
export const CLEAR_BRIEF = 'CLEAR_BRIEF';
export const SET_REGROUPEMENT_PERSONNALISE = 'SET_REGROUPEMENT_PERSONNALISE';
export const SET_IS_VIEW_UPDATE = 'SET_IS_VIEW_UPDATE';
export const SET_PERIODE_OF_PRODUCT = 'SET_PERIODE_OF_PRODUCT';
export const SET_CRITERES_RECHERCHE = 'SET_CRITERES_RECHERCHE';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
